<template>
  <div>
    <cash-flow-filter @input="select()" :searchParams="searchParams" />
    <br />
    <cash-flow-list
      :loading="loading"
      :accountTransactions="accountTransactions"
    />
    <v-pagination
      v-model="searchParams.page"
      :length="accountTransactions.last_page"
      @input="select($event)"
      :total-visible="9"
    />
  </div>
</template>

<script>
import CashFlowFilter from "@/components/cash-flow/filter/CashFlowFilter.vue";
import CashFlowList from "@/components/cash-flow/lists/CashFlowList.vue";
export default {
  components: { CashFlowFilter, CashFlowList },

  data() {
    return {
      searchParams: { page: 1, account_plan_id: [] },
      accountTransactions: {},
      loading: false,
    };
  },

  mounted() {
    this.select();
  },

  methods: {
    async select(page = 1) {
      this.searchParams.page = page;
      this.loading = true;
      await this.$http
        .index("account/account-transaction", this.searchParams)
        .then((response) => {
          this.accountTransactions = response.accountTransactions;
          this.loading = false;
        });
    },
  },
};
</script>


<style>
</style>